import {Component} from "preact";
import {Icon} from "./Icon";
import {Spinner} from "./Spinner";
import style from "./TextInput.module.css";

export interface TextInputProps {
	value: string;
	onChange: (value: string) => void;
	onBackspace?: () => void;
	disabled?: boolean;
	readOnly?: boolean;
	pending?: boolean;
	required?: boolean;
	placeholder?: string;
	type: "password" | "text" | "phone";
}

export class TextInput extends Component<TextInputProps> {
	render() {
		const {value, onBackspace, disabled, readOnly, type, children, pending, required, placeholder} = this.props;
		return (
			<div class={style.textInput}>
				{pending && (
					<div class={style.pendingIcon}>
						<Spinner class={style.pendingIcon} />
					</div>
				)}
				<input
					type={type}
					onChange={this.handleChange}
					value={value}
					disabled={disabled}
					readOnly={readOnly}
					required={required}
					placeholder={placeholder}
				/>
				{onBackspace && (
					<button onClick={onBackspace} disabled={disabled} class={style.backspace}>
						<Icon>backspace</Icon>
					</button>
				)}
				{children}
			</div>
		);
	}

	private handleChange = (e: Event) => {
		const input = e.target as HTMLInputElement;
		this.props.onChange(input.value);
	};
}
